import { useLocation } from "@reach/router";
import { useContext, useEffect } from "react";
import {
    trackPageView,
    getShopifyPageType,
    getCollectionHandleFromPath,
    getSearchStringFromLocation,
} from "helpers/shopify-analytics";
import { useShopifyTrackingCookies } from "helpers/shopify-session-cookies";
import { AccountContext } from "context/account";

/**
 * Shopify Analytics page views + Phase 3 tracking cookies
 * (fetchTrackingValues via same-origin Storefront API proxy).
 */
const useShopifyAnalytics = () => {
    const location = useLocation();
    const { account } = useContext(AccountContext) || {};
    const customerId = account?.user?.id;
    const cookiesReady = useShopifyTrackingCookies(true);

    useEffect(() => {
        if (!cookiesReady) return;

        const pathname = location?.pathname || "/";
        const pageType = getShopifyPageType(pathname);
        const collectionHandle = getCollectionHandleFromPath(pathname);
        const searchString = getSearchStringFromLocation(location?.search);

        trackPageView({
            pageType,
            ...(collectionHandle ? { collectionHandle } : {}),
            ...(searchString ? { searchString } : {}),
            ...(customerId ? { customerId } : {}),
        });
    }, [cookiesReady, location?.pathname, location?.search, customerId]);
};

export default useShopifyAnalytics;
